import { useState, useEffect } from "react";

interface Props {
  expiresAt: string;
}

function formatDuration(ms: number): string {
  if (ms <= 0) return "Expired";

  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));

  if (hours > 24) {
    const days = Math.floor(hours / 24);
    return `${days}d ${hours % 24}h remaining`;
  }
  if (hours > 0) {
    return `${hours}h ${minutes}m remaining`;
  }
  return `${minutes}m remaining`;
}

export default function Countdown({ expiresAt }: Props) {
  const [remaining, setRemaining] = useState(() => {
    return new Date(expiresAt).getTime() - Date.now();
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(new Date(expiresAt).getTime() - Date.now());
    }, 60000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  const isUrgent = remaining < 1000 * 60 * 60 * 2;

  return (
    <div
      className={`text-sm ${isUrgent ? "text-red-400" : "text-gray-400"}`}
    >
      {formatDuration(remaining)}
    </div>
  );
}
